import React from "react";
import localeText from "../../../../../../../locale";
import { SHIPPING_OPTIONS } from "../constants";
import { RadioButton } from "primereact/radiobutton";

function ShippingOptionCards({ value, onChange, showSendCloud, onSendCloud }) {
  const options = showSendCloud
    ? [
        {
          value: 1,
          titleKey: "included",
          descKey: "includesTax",
        },
        ...SHIPPING_OPTIONS,
      ]
    : SHIPPING_OPTIONS;

  return (
    <div className="product-form-shipping">
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            className={`product-form-shipping-card${selected ? " is-selected" : ""} flex align-items-start justify-content-between`}
            onClick={() => {
              onChange(option.value);
              if (option.value === 1) onSendCloud?.();
            }}
          >
            <div className="flex flex-column gap-1">
              <div className="product-form-shipping-title text-sm font-medium m-0">
                {localeText(option.titleKey)}
              </div>
              <div className="product-form-help m-0">{localeText(option.descKey)}</div>
            </div>
            <RadioButton className="shipping-radio-button" checked={selected} onChange={(e) => onChange(e.value)} />
          </button>
        );
      })}
    </div>
  );
}

export default ShippingOptionCards;
